<template>
  <div class="main">
    <dl class="row">
      <dt class="col">
        <span class="btn btn-outline-warning btn-sm pull-right" style="margin-right:8px" v-on:click="toScan()"><strong><i
              class="fa fa-minus-square-o"></i> スタンプを受け取る</strong></span>
      </dt>
    </dl>
    <div class="nav nav-fill row">
      <div class="nav-item-active col" v-for="item in items" :key="item.id">
        <i class="fa fa-check-circle fa-4x"></i><br>{{ item[3] }}
      </div>
      <div class="nav-item-none col" v-for="n in cnt" :key="n">
        <div v-if="n < cnt">
          <i v-if="n < cnt" class="fa fa-circle-thin fa-4x"></i><br>0000.00.00
        </div>
        <div v-if="n == cnt">
          <p class="goal"><i class="fa fa-circle-thin fa-4x"></i><br><b>GOAL</b></p>
        </div>
      </div>
    </div>
    <dl class="row">
      <dt class="col-3">特典</dt>
      <dd class="col-9 text-left">
        <p>スタンプが五つたまったら<br>
          次回来店時ﾗﾝﾁﾀｲﾑ・ﾃｲｸｱｳﾄ500円OFF<br>
          又はﾃﾞｨﾅｰﾀｲﾑ1000円OFF!</p>
      </dd>
      <dt class="col-3">条件</dt>
      <dd class="col-9 text-left">
        <p>ﾗﾝﾁ・ﾃﾞｨﾅｰ・ﾃｲｸｱｳﾄ<br>
          ご利用1回スタンプ1回押印<br>
          会計時にお伝えください。</p>
      </dd>
      <dd class="col-12 text-left">
        <p class="text-muted small">
          ※1000円以上のご利用に限ります（お子様ﾗﾝﾁ不可）<br>
          ※他券・他サービス・クレジットカード併用不可<br>
          ※他のお客様とのスタンプの共有はできません<br>
          ※一家族での会計の場合、お食事1回につき1枚ご利用できます（複数不可）<br>
        </p>
      </dd>
      <dd class="col-12 text-left">
        <span class="btn-sm  btn-warning" style="margin-right:0px"
          v-on:click="toStamp()"><strong>スタンプカードを使用する</strong></span>
      </dd>
    </dl>
  </div>
</template>
<script>
import sx from '../utils/core.js'

export default {
  created() {
    this.$store.state.title = 'スタンプ'
  },
  data() {
    return {
      items: [],
      cnt: 0
    }
  },
  methods: {
    toScan() {
      this.$router.replace({ name: 'Scan' })
    },
    toStamp() {
      this.$router.replace({ name: 'StampList' })
    }
  },
  mounted() {
    const that = this
    if (!that.$store.state.authenticated) {
      that.$router.replace({ name: 'Login' })
    }
    sx.showWaiting()
    var params = {
      bucketid: 17,
      token: localStorage.getItem('token')
    }
    var url = that.$store.state.baseurl + '/app/mshelper/fetchStampDetails'
    sx.request(
      url,
      params,
      function (result) {
        if (result.status === 'ok') {
          if (result.data.rows.length == 1 && result.data.rows[0][2] == null) {
            that.items = []
            that.cnt = result.data.rows[0][0]
            that.$store.state.stampid = result.data.rows[0][1]
          } else {
            that.items = result.data.rows
            that.cnt = that.items[0][0] - that.items.length
            that.$store.state.stampid = result.data.rows[0][1]
          }
          sx.hideWaiting()
        } else if (result.status === 'outdated') {
          that.$router.replace({ name: 'Login' })
        } else {
          sx.toastSuccess(result.message)
          console.log(result.message)
          sx.hideWaiting()
        }
      },
      function () {
        sx.request(
          url,
          params,
          function (result) {
            if (result.status === 'ok') {
              if (result.data.rows.length == 1 && result.data.rows[0][2] == null) {
                that.items = []
                that.cnt = result.data.rows[0][0]
                that.$store.state.stampid = result.data.rows[0][1]
              } else {
                that.items = result.data.rows
                that.cnt = that.items[0][0] - that.items.length
                that.$store.state.stampid = result.data.rows[0][1]
              }
              sx.hideWaiting()
            } else if (result.status === 'outdated') {
              that.$router.replace({ name: 'Login' })
            } else {
              sx.toastSuccess(result.message)
              console.log(result.message)
              sx.hideWaiting()
            }
          },
          function (result) {
            that.$router.replace({ name: 'Login' })
            console.log("wrong")
          }
        )
      }
    )
    sx.hideWaiting()
  }
}
</script>
<style scoped>
.main {
  margin: 20px 0 0 0
}

.nav {
  font-size: 8pt;
}

.nav .nav-item-active {
  color: #fb6e14;
  margin-bottom: 20px;
}

.nav .nav-item-none {
  color: #b2b2b2;
}

.goal {
  color: #b2b2b2
}

.row {
  margin-right: 0;
  margin-left: 0;
}

.col {
  padding-right: 4px;
  padding-left: 4px;
}

.status {
  height: 36rpx;
  line-height: 36rpx;
  font-size: 10pt;
  width: 300px;
  text-align: center;
  justify-content: center;
  margin-bottom: 10rpx;
  border-radius: 4px;
  padding: 0 10rpx;
  margin-right: 10rpx;
  background: #CCCCCC;
  color: black;
  margin: 2px;
  padding: 6px;
}

.ing {
  background: #FF9966;
  color: white;
}

.on {
  background: #99CC66;
  color: white;
}

.off {
  background: #CCCCCC;
  color: black;
}
</style>
